import styled from 'styled-components';
import { RoutesString } from 'common-modules/general/Config/routesString';
import { GetStyledCompImg } from 'common-modules/general/Modules/functions';
const FooterLogoArea = styled.div`
  display: table-cell;
  vertical-align: top;
  width: 217px;
  width: 13.5625rem;
`;
const LogoIma = styled.img``;

const Logo = () => {
  return (
    <FooterLogoArea>
      <a href={RoutesString.Main}>
        <LogoIma src={GetStyledCompImg('common/img_footer_logo.png')} alt="DL건설" />
      </a>
    </FooterLogoArea>
  );
};

export default Logo;
